<template>
  <td>{{ formattedInsurance }}</td>
</template>

<script>
  import utils from '../../../../utils';
  import { mapGetters } from 'vuex';

  export default {
    name: "TableInsuranceLabel",
    props: ['insurance'],
    computed: {
      ...mapGetters(['currency']),
      formattedInsurance() {
        return utils.convertSystemToCurrency(this.insurance, this.currency);
      },
    }
  }
</script>

<style scoped>
  td {
    text-align: right !important;
    color: #999 !important;
  }
</style>

